export const POLICY = {
  ALL: '*',
  USERS_GET: 'auth.read',
  USERS_CREATE_UPDATE: 'auth.read-write',
  BINARIES_GET: 'binaries.read',
  BINARIES_CREATE_UPDATE: 'binaries.read-write',
  CLIENT_CONF_GET: 'client-configuration.read',
  CLIENT_CONF_CREATE_UPDATE: 'client-configuration.read-write',
  ENGINES_GET: 'engines.read',
  GAME_CONF_GET: 'game-configuration.read',
  GAME_CONF_GET_EXT: 'external-game.read',
  GAME_CONF_CREATE_UPDATE_EXT: 'external-game.read-write',
  GAME_CONF_CREATE_UPDATE: 'game-configuration.read-write',
  GAME_OPERATORS_GET: 'game-operators.read',
  GAME_OPERATORS_CREATE_UPDATE: 'game-operators.read-write',
};

export const PACKAGE_TYPE = {
  CLIENT: 'Client',
  GAME: 'Game',
  PAY_TABLE: 'PayTable',
};

// {
//   "*": [
//   "Everything"
// ],
//   "auth.read": [
//   "Getting all users"
// ],
//   "auth.read-write": [
//   "Getting all users",
//   "Registering new users"
// ],
//   "binaries.read": [
//   "Getting all binaries"
// ],
//   "binaries.read-write": [
//   "Getting all binaries",
//   "Updating existing binaries",
//   "Addind new binaries"
// ],
//   "client-configuration.read": [
//   "Getting all client configurations"
// ],
//   "client-configuration.read-write": [
//   "Getting all client configurations",
//   "Updating existing client configurations",
//   "Adding new client configurations"
// ],
//   "currencies.read": [
//   "Getting all currencies"
// ],
//   "engines.read": [
//   "Getting all engines"
// ],
//   "external.read": [
//   "Getting all external client configs",
//   "Getting all external game configs"
// ],
//   "game-configuration.read": [
//   "Getting all game configurations"
// ],
//   "game-configuration.read-write": [
//   "Getting all game configurations",
//   "Adding new game configuration",
//   "Updating existing game configurations",
//   "Toggling game config"
// ],
//   "game-operators.read": [
//   "Getting all operators",
//   "Getting all game operator configs"
// ],
//   "game-operators.read-write": [
//   "Getting all operators",
//   "Getting all game operator configs",
//   "Creating game operator config",
//   "Toggling game operator config"
// ],
//   "limit-configuration.read": [
//   "Getting all operator limits"
// ],
//   "limit-configuration.read-write": [
//   "Getting all operator limits",
//   "Adding new operator limit",
//   "Updating existing operator limit"
// ]
// }
